<template>
  <div id="app">
    <Header :stock="stock" />
    <div class="head-blank">
      <div v-for="(data, i) in stock" :key="i" :value="data">
        <Chart
          bg="bg-white"
          :id="data.name.split(' ')[0]"
          :stock_id="data._id"
          :color="color[i]"
          :stock="data"
        />
      </div>
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import Chart from "./Chart.vue";
import Header from "./Header.vue";

export default {
  name: "app",

  components: { Chart, Header },
  data() {
    return {
      stock: [],
      color: [
        "#a50000",
        "#ff1d68",
        "#ffd000",
        "#ff9d1d",
        "#0004ff",
        "#181818",
        "#ff0037",
        "#b6001e",
        "#00195f",
        "#002b07",
      ],
    };
  },

  mounted() {
    this.getStock();
    setInterval(() => {
      this.getStock();
    }, 600000);
  },
  methods: {
    getStock() {
      this.$http
        .get(`${process.env.VUE_APP_BACKEND_API_URL}/stock`)
        .then(({ data }) => {
          this.stock = data;
          for (var i = 0; i < data.length; i++) {
            this.stockId.push(data[i]._id);
          }
        })
        .catch((err) => {
          return err;
        });
    },
  },
};
</script>

<style>
.d {
  color: #0004ff;
}

@media (max-width: 575.98px) {
}
</style>
